/** Body paragraph outside quotes / resource rows (no role attrs). */
export const BODY_PARAGRAPH_ATTRS = {
  psRowRole: null,
  psQuoteRole: null,
  postTextStyle: null,
  postTextAccent: null,
};

export function createBodyParagraph(schema) {
  const paragraphType = schema.nodes.paragraph;
  if (!paragraphType) return null;
  return paragraphType.create(BODY_PARAGRAPH_ATTRS);
}
